import { Component } from '@theme/component';

/**
 * @typedef {object} SiblingProductPickerRefs
 * @property {HTMLSelectElement} select - The sibling product select element.
 */

/**
 * A custom element that navigates to the selected sibling product's page.
 * Unlike the variant picker, sibling products are separate products (not
 * variants of the same product), so selection is a full page navigation
 * rather than a fetch/morph.
 *
 * @extends Component<SiblingProductPickerRefs>
 */
export default class SiblingProductPicker extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('change', this.#handleChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#handleChange);
  }

  #handleChange = () => {
    const url = this.refs.select?.value;
    if (!url) return;

    window.location.href = url;
  };
}

if (!customElements.get('sibling-product-picker')) {
  customElements.define('sibling-product-picker', SiblingProductPicker);
}
